export enum PermissionKeys {
    Store = 'Store',
    Profile = 'Profile',
    Orders = 'Orders',
    Cart = 'Cart',
    SimManagement = 'SimManagement',
    Referral = 'Referral',
}
